module.exports = __webpack_public_path__ + "static/media/1.61fd5287.jpg";